
import { defineComponent, computed } from 'vue'
import { useStore } from 'vuex'
import { FieldStructure } from '@/contracts/forms/FieldContracts'

export default defineComponent(
{
    name: 'SuccessConfirmation',
    setup()
    {
        // Load vuex:
        const store = useStore()
        // Computed state params:
        const confirmationExists = computed(() =>
        {
            return store.getters['confirmations/confirmationExists']
        })
        const confirmationData = computed(() =>
        {
            return store.getters['confirmations/confirmationData']
        })

        // Return data:
        return {
            confirmationExists,
            confirmationData
        }
    }
})
